module.exports = __webpack_public_path__ + "img/46_34.9b67a721.png";